/**
 * header-interactions.js
 * 参照 walkinpets.com 的 header 交互逻辑
 * 处理：汉堡菜单、移动端子菜单折叠、搜索切换、滚动检测、点击外关闭
 */
(function () {
  'use strict';

  // 等待 DOM 就绪
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var body = document.body;
    var header = document.querySelector('.header-group .site-header');
    var menu = document.querySelector('.header-group .site-header .flex .menu');
    var menuToggle = document.querySelector('.header-group .site-header .flex .menu-device-toggle');
    var searchToggle = document.querySelector('.header-group .site-header .flex .controls .icon-search');
    var announcementBar = document.querySelector('.header-group .section-announcement-bar');
    var headerGroup = document.querySelector('.header-group');

    // ============================================================
    // 汉堡菜单 Toggle（移动端）
    // ============================================================
    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var isExpanded = body.classList.contains('menu-expanded');
        body.classList.toggle('menu-expanded', !isExpanded);
        menuToggle.setAttribute('aria-expanded', String(!isExpanded));
      });
    }

    // ============================================================
    // 移动端：子菜单展开/折叠（j-toggle-childlinks）
    // ============================================================
    document.querySelectorAll('.header-group .j-toggle-childlinks').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.innerWidth >= 1024) return; // 桌面端由 CSS hover 处理
        e.preventDefault();
        var li = this.closest('li');
        if (li) {
          li.classList.toggle('expanded');
        }
      });
    });

    // ============================================================
    // 搜索框 Toggle
    // ============================================================
    if (searchToggle && header) {
      searchToggle.addEventListener('click', function () {
        header.classList.toggle('search-active');
        if (header.classList.contains('search-active')) {
          // 聚焦搜索框
          var searchInput = header.querySelector('form input[type="search"], form input[name="q"]');
          if (searchInput) {
            setTimeout(function () { searchInput.focus(); }, 100);
          }
        }
      });
    }

    // ============================================================
    // 点击页面其他区域关闭菜单
    // ============================================================
    document.addEventListener('click', function (e) {
      if (!body.classList.contains('menu-expanded')) return;
      if (!menu || !menuToggle) return;
      if (!menu.contains(e.target) && !menuToggle.contains(e.target)) {
        body.classList.remove('menu-expanded');
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // 点击页面关闭搜索
    document.addEventListener('click', function (e) {
      if (!header || !header.classList.contains('search-active')) return;
      if (!searchToggle) return;
      var searchForm = header.querySelector('.logo-with-search form');
      if (
        searchForm && !searchForm.contains(e.target) &&
        searchToggle && !searchToggle.contains(e.target)
      ) {
        header.classList.remove('search-active');
      }
    });

    // ============================================================
    // 滚动检测（公告栏消失后 header sticky 位移）
    // ============================================================
    var ticking = false;

    function updateAnnouncementHeight() {
      var announcementH = announcementBar ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-height', announcementH + 'px');
    }

    // 初始化与监听窗口大小变化
    updateAnnouncementHeight();
    window.addEventListener('resize', updateAnnouncementHeight, { passive: true });

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = window.scrollY || window.pageYOffset;
          var announcementH = announcementBar ? announcementBar.offsetHeight : 0;
          if (scrollY > announcementH) {
            body.classList.add('scrolled');
          } else {
            body.classList.remove('scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // ============================================================
    // Loyalty launcher language fallback
    // ============================================================
    (function localizeRewardsLauncher() {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      var rewardLabel = '';

      if (lang === 'zh-cn' || lang.indexOf('zh-hans') === 0) {
        rewardLabel = '积分奖励';
      } else if (lang === 'zh-tw' || lang.indexOf('zh-hant') === 0) {
        rewardLabel = '積分獎勵';
      }

      if (!rewardLabel) return;

      function cleanText(element) {
        return ((element && (element.innerText || element.textContent)) || '').replace(/\s+/g, ' ').trim();
      }

      function setButtonText(button) {
        var spans = button.querySelectorAll('span');

        for (var i = 0; i < spans.length; i++) {
          if (cleanText(spans[i]).toLowerCase() === 'rewards') {
            spans[i].textContent = rewardLabel;
            button.setAttribute('aria-label', rewardLabel);
            return;
          }
        }

        if (cleanText(button).toLowerCase() === 'rewards') {
          button.textContent = rewardLabel;
          button.setAttribute('aria-label', rewardLabel);
        }
      }

      function localize() {
        document.querySelectorAll('button, [role="button"]').forEach(function (button) {
          if (cleanText(button).toLowerCase() === 'rewards') {
            setButtonText(button);
          }
        });
      }

      localize();
      setTimeout(localize, 500);
      setTimeout(localize, 1500);
      setTimeout(localize, 3500);

      if ('MutationObserver' in window && document.body) {
        var observer = new MutationObserver(localize);
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () {
          observer.disconnect();
        }, 10000);
      }
    })();

    // ============================================================
    // Giving Back cache guard
    // ============================================================
    (function () {
      if (
        window.location.pathname.indexOf('/pages/giving-back') === -1 &&
        window.location.pathname.indexOf('/pages/monthly-rescue-support') === -1
      ) return;

      document.documentElement.classList.add('tgb-giving-back-page');

      function textOf(element) {
        return ((element && (element.innerText || element.textContent)) || '').replace(/\s+/g, ' ').trim();
      }

      function hideGivingBackNoise() {
        document.querySelectorAll('[id^="futureblink-popup"], [id^="futureblink-popup-overlay"], #wa-correct-after-icons, #wa-correct-button, .honeypop-cp, [class*="honeypop"], [class*="rewards-widget"], [id*="rewards-widget"]').forEach(function (element) {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.setAttribute('aria-hidden', 'true');
        });

        document.querySelectorAll('main div, main section, main article, main aside').forEach(function (element) {
          var text = textOf(element).toLowerCase();
          if (text.indexOf('points for this order') !== -1 && text.indexOf('redeem rewards') !== -1 && text.length < 220) {
            element.style.display = 'none';
            element.style.visibility = 'hidden';
            element.setAttribute('aria-hidden', 'true');
          }
        });

        document.querySelectorAll('button, [role="button"]').forEach(function (element) {
          if (textOf(element).toLowerCase() === 'rewards') {
            element.style.display = 'none';
            element.style.visibility = 'hidden';
            element.setAttribute('aria-hidden', 'true');
          }
        });
      }

      function setupGivingBackCare() {
        var section = document.querySelector('[data-tgb-section]');
        if (!section || section.dataset.tgbGlobalGuard === 'ready') return;
        section.dataset.tgbGlobalGuard = 'ready';

        var headingEyebrow = section.querySelector('#monthly-care .tgb-heading .tgb-eyebrow');
        var headingTitle = section.querySelector('#monthly-care .tgb-heading h2');
        var headingText = section.querySelector('#monthly-care .tgb-heading__text');
        var choiceLabel = section.querySelector('.tgb-pledge__header span');
        var choiceTitle = section.querySelector('.tgb-pledge__header strong');
        var choiceText = section.querySelector('.tgb-pledge__header p');

        if (headingEyebrow) headingEyebrow.textContent = 'Monthly care promise';
        if (headingTitle) headingTitle.textContent = 'Choose a small promise.';
        if (headingText) headingText.innerHTML = '<p>Pick $1, $5, or $10 each month. Each choice holds one practical need: a meal, a clean place to rest, or a ride to care.</p>';
        if (choiceLabel) choiceLabel.textContent = 'Choose monthly care';
        if (choiceTitle) choiceTitle.textContent = 'One quiet way to help.';
        if (choiceText) choiceText.textContent = 'Small monthly support should feel simple, clear, and connected to a real need.';

        var plans = Array.prototype.slice.call(section.querySelectorAll('[data-tgb-plan]'));
        var liveName = section.querySelector('[data-tgb-live-name]');
        var liveUse = section.querySelector('[data-tgb-live-use]');
        var liveAmount = section.querySelector('[data-tgb-live-amount]');
        var liveBadge = section.querySelector('[data-tgb-live-badge]');
        var liveBadgeName = section.querySelector('[data-tgb-live-badge-name]');
        var checkoutButton = section.querySelector('[data-tgb-checkout]');
        var checkoutStatus = section.querySelector('[data-tgb-checkout-status]');
        var badgeTemplates = {};

        section.querySelectorAll('[data-tgb-badge-template]').forEach(function (template) {
          badgeTemplates[template.dataset.tgbBadgeTemplate] = template.innerHTML.trim();
        });

        function setBadge(kind) {
          if (!liveBadge) return;
          var badgeKind = kind || 'empty';
          liveBadge.className = 'tgb-badge tgb-badge--large tgb-badge--' + badgeKind;
          if (badgeTemplates[badgeKind] || badgeTemplates.empty) {
            liveBadge.innerHTML = badgeTemplates[badgeKind] || badgeTemplates.empty;
          }
        }

        function readyLabel(plan) {
          var amount = (plan && plan.dataset.amount) || '';
          var label = (checkoutButton && checkoutButton.dataset.readyLabel) || 'Continue with [amount] monthly';
          return label.replace('[amount]', amount).replace('{amount}', amount).replace('[[amount]]', amount);
        }

        function resetPlans() {
          plans.forEach(function (plan) {
            plan.classList.remove('is-active');
            plan.setAttribute('aria-checked', 'false');
          });
          if (liveName) liveName.textContent = 'Choose a care role first.';
          if (liveUse) liveUse.textContent = 'Your line badge and checkout button will be ready after you choose.';
          if (liveAmount) liveAmount.textContent = 'Choose';
          if (liveBadgeName) liveBadgeName.textContent = 'Care role';
          setBadge('empty');
          if (checkoutButton) {
            checkoutButton.disabled = true;
            checkoutButton.textContent = checkoutButton.dataset.chooseLabel || 'Choose $1, $5, or $10 first';
          }
          if (checkoutStatus) {
            checkoutStatus.textContent = 'You can review everything before paying. Public display is optional and shown only with permission.';
            checkoutStatus.classList.remove('is-error');
          }
        }

        function applyPlan(plan) {
          if (!plan) return;
          plans.forEach(function (item) {
            var active = item === plan;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          if (liveName) liveName.textContent = plan.dataset.title || ((plan.dataset.badge || 'Care') + ' is ready.');
          if (liveUse) liveUse.textContent = plan.dataset.use || '';
          if (liveAmount) liveAmount.textContent = ((plan.dataset.amount || '') + '/mo').trim();
          if (liveBadgeName) liveBadgeName.textContent = (plan.dataset.badge || 'Care') + ' badge';
          setBadge(plan.dataset.badgeKind || 'empty');
          if (checkoutButton) {
            checkoutButton.disabled = false;
            checkoutButton.textContent = readyLabel(plan);
          }
          if (checkoutStatus) {
            checkoutStatus.textContent = 'You can review everything before paying. Public display is optional and shown only with permission.';
            checkoutStatus.classList.remove('is-error');
          }
        }

        plans.forEach(function (plan) {
          plan.addEventListener('click', function () {
            window.setTimeout(function () { applyPlan(plan); }, 0);
          });
        });

        resetPlans();
      }

      hideGivingBackNoise();
      setupGivingBackCare();
      window.setTimeout(hideGivingBackNoise, 250);
      window.setTimeout(setupGivingBackCare, 250);
      window.setTimeout(hideGivingBackNoise, 900);
      window.setTimeout(setupGivingBackCare, 900);

      if (document.body) {
        var givingBackObserver = new MutationObserver(function () {
          hideGivingBackNoise();
          setupGivingBackCare();
        });
        givingBackObserver.observe(document.body, { childList: true, subtree: true });
        window.setTimeout(function () { givingBackObserver.disconnect(); }, 10000);
      }
    })();

    // ============================================================
    // 购物车数量更新
    // ============================================================
    function updateCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
          });
        })
        .catch(function () {});
    }

    // 监听 Shopify cart 更新事件（如果主题有）
    document.addEventListener('cart:updated', updateCartCount);
  });
})();
